import { memo } from 'preact/compat'
import { getStylesFn } from 'core/helpers/styles'
import i18n from 'core/services/i18n'
import { ElementHostsOptions } from 'core/types/element/element_hosts'

const STYLES = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '0 10px'
}

const IMG_STYLES = {
  borderRadius: 15,
  width: 45,
  height: 45,
  objectFit: 'cover'
}

const extractNameStyles = getStylesFn(
  [
    'color',
    'lineHeight',
    'textTransform',
    'textDecoration',
    'letterSpacing',
    'textShadow',
    'fontFamily',
    'fontSize',
    'fontWeight'
  ],
  {
    textAlign: 'center',
    marginTop: 7,
    marginBottom: 2
  }
)

const extractRoleStyles = getStylesFn(
  [
    'color',
    'lineHeight',
    'textTransform',
    'textDecoration',
    'letterSpacing',
    'textShadow',
    'fontFamily',
    'fontSize',
    'fontWeight'
  ],
  {
    textAlign: 'center'
  }
)

type Props = {
  options: ElementHostsOptions
  avatarUrl: string
  firstName: string
  lastName: string
}

const Host = (props: Props) => {
  const { avatarUrl, firstName, lastName, options } = props

  const nameStyles = extractNameStyles(options.name)
  const roleStyles = extractRoleStyles(options.role)

  return (
    <div style={STYLES} className="wf_reset wf_hosts">
      <img style={IMG_STYLES} className="wf_reset wf_hosts_image" src={avatarUrl} />
      <div style={nameStyles} className="wf_reset wf_hosts_name">{`${firstName} ${lastName}`}</div>
      <div style={roleStyles} className="wf_reset wf_hosts_role">
        {i18n.t('layout.field.host')}
      </div>
    </div>
  )
}

export default memo(Host)
